
const deepImages = Array.from({ length: 7 }, (_, i) =>
  `/gallery/deep/${i + 1}.jpeg`
);

const hardfloorImages = Array.from({ length: 12 }, (_, i) =>
  `/gallery/hard-floor/${i + 1}.jpeg`
);

const windowImages = Array.from({ length: 6 }, (_, i) =>
  `/gallery/window/${i + 1}.jpeg`
);

const pressureImages = Array.from({ length: 4 }, (_, i) =>
  `/gallery/pressure/${i + 1}.jpeg`
);

const tileImages = Array.from({ length: 4 }, (_, i) =>
  `/gallery/tile/${i + 1}.jpeg`
);

const standardImages = Array.from({ length: 9 }, (_, i) =>
  `/gallery/standard/${i + 1}.jpeg`
);

const carpetImages = Array.from({ length: 7 }, (_, i) =>
  `/gallery/carpet/${i + 1}.jpeg`
);



export const galleryCategories = [

  {
    id: 'Genaral',
    title: 'Genaral Cleaning',
    cover: '/gallery/standard/2.jpeg',
    images: standardImages,
  },
  {
    id: 'deep',
    title: 'Deep Cleaning',
    cover: '/gallery/deep/5.jpeg',
    images: deepImages,
  },
  {
    id: 'hard-floor',
    title: 'Hard Floor Maintaining',
    cover: '/gallery/hard-floor/7.jpeg',
    images: hardfloorImages,
  },
  {
    id: 'window',
    title: 'Window Cleaning',
    cover: '/gallery/window/4.jpeg',
    images: windowImages,
  },
  {
    id: 'pressure',
    title: 'Pressure Washing',
    cover: '/gallery/pressure/3.jpeg',
    images: pressureImages,
  },
  {
    id: 'tile',
    title: 'Tile & Grout Cleaning',
    cover: '/gallery/tile/1.jpeg',
    images: tileImages,
  },

  {
    id: 'Carpet',
    title: 'Carpet & Upholstery Steam Cleaning',
    cover: '/gallery/carpet/2.jpeg',
    images: carpetImages,
  },
  

];
